export default "__VITE_ASSET__CgTgU9Hf__"